import React, { useMemo } from "react";
import { OrderItData } from "./order.it.data";
import { DisplayData, DisplayDataProps, DisplayDataWidget, translateLabelForData } from "@me8eon/data";
import { useAttributeValueComponents, useRenderers, IconAndTitle } from "@me8eon/renderers";
import { } from "@me8eon/clip_height";
import { SimpleWidget } from "@me8eon/simple_widget";
import { ThemedIcon } from "@me8eon/icons";
import { useCommonComponents } from "@me8eon/components";
// @ts-ignore
import cart from "./cart.svg"

export const OrderItDisplay: DisplayData<OrderItData> =
    ({ rootId, id, data }: DisplayDataProps<OrderItData>) => {
        const { H1WithIconAndUrl, Markdown, Url } = useRenderers();
        const { ClipHeight } = useCommonComponents();
        const { Text, DataLayout } = useAttributeValueComponents();
        const newRootId = `${rootId}.${id}`;
        const issueSummaryAndUrl = useMemo(() =>
            ({ url: data.link, title: `${data.title}`, icon: () => <ThemedIcon name="cart" /> }), [data.link, data.title]);
        return <DataLayout rootId='orderit' className='order-it-data' layout={[1, 1, 3, 1]}>
            <H1WithIconAndUrl rootId={newRootId} attribute={translateLabelForData('name')} value={issueSummaryAndUrl} />
            {data.description !== 'undefined' ? <ClipHeight maxHeight='2rem' force={false}>
                <Markdown rootId={id} attribute={translateLabelForData('data.description')} value={data.description} />
            </ClipHeight> : <></>}
            <Text rootId={id} attribute={translateLabelForData('source')} value='My IT order' />
            <Text rootId={id} attribute={translateLabelForData('type')} value={data.type} />
            {/* <Text rootId={id} attribute={translateLabel('deliveryTime')} value={data.deliveryTime} /> */}
            <Text rootId={id} attribute={translateLabelForData('category')} value={data.category} />
            <Url rootId={id} attribute={translateLabelForData('url')} value={data.link} />
        </DataLayout>;
    };

export const OneLineOrderItDisplay: DisplayData<OrderItData> =
    ({ data, listItemClicked }: DisplayDataProps<OrderItData>) => {
        const { SearchListItem } = useRenderers();
        const issueSummaryAndUrl: IconAndTitle = useMemo(() =>
        ({
            title: `${data.title}`,
            icon: cart,
            onClick: () => { listItemClicked && listItemClicked(`${data.title}`); },
        }), [data]);
        return (
            <SearchListItem key={data.title} rootId={data.title} attribute={translateLabelForData("name")} value={issueSummaryAndUrl} />
        );
    };

export const SimpleOrderItWidget: DisplayDataWidget<OrderItData> =
    SimpleWidget(
        ['name'],
        ['title'],
        []);

